import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "首页", href: "#top" },
  { label: "下载方式", href: "#methods" },
  { label: "教程步骤", href: "#tutorial" },
  { label: "工具推荐", href: "#tools" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-8 py-3.5">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span
            className={`font-display text-xl ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            漫藏手册
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-100"
                    : "text-background-50/90 hover:text-background-50 hover:bg-white/15"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#tutorial"
          className="hidden md:inline-flex whitespace-nowrap items-center gap-1.5 text-sm font-semibold px-5 py-2.5 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
        >
          开始下载
          <i className="ri-arrow-right-line"></i>
        </a>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg border border-background-200 text-foreground-950 bg-background-50"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden px-4 pb-4">
          <ul className="flex flex-col gap-1 rounded-2xl bg-background-100 p-2">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between px-4 py-3 rounded-xl text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}